import styled from "styled-components";
import { RadioBlob } from "../RadioBlob/styles.ts";

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const RadioOption = styled.button`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  max-width: 100%;
  width: 100%;
  ${RadioBlob} {
    position: relative;
    top: 3px;
  }
`;

export const RadioOptionLabel = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.default[700]};
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  text-align: left;
  display: flex;
`;

export const RadioWrapper = styled.div`
  max-width: 100%;
  width: 100%;
  height: 100%;
  max-height: 100%;
`;
